module.exports = __webpack_public_path__ + "static/media/talent-feature-interview-offer@2x.9ce850a4.png";